export interface Branch {
    id: string;
    code: string;
    name: string;
    type: string;
    schedule: Schedule;
    rentalDays?: number;
    freeDays?: number;
    discounts: Discount[];
    vehicles: Vehicle[];
    total: number;
    vehicleTypes?: VehicleType[];
}

export interface VehicleType {
    id: number;
    nombre: string;
    nombre_en: string;
    orden: number;
    eliminado: boolean;
    image?: string;
}

export interface Tax {
    tax: string;
    charge: number;
    currency: string;
}

export interface ChargesDetail {
    amount: number;
    discount: number;
    totalDiscount?: number;
    rentRate: number;
    taxes: Tax[];
    currency: string;
    rentType?: string;
}

export interface Charges {
    office: ChargesDetail;
    prepaid?: ChargesDetail;
}

export interface Features {
    air?: boolean;
    doors?: number;
    luggage?: number;
    passengers?: number;
    radio?: boolean;
    transmission?: string;
}

export interface VehicleFeature {
    name: string;
    img: string;
    quantity?: number | null;
}

export type VehicleFeatures = Features | VehicleFeature[];

export function isFeatureList(
    features: VehicleFeatures | undefined | null,
): features is VehicleFeature[] {
    return Array.isArray(features);
}

export function isFeatureFlags(
    features: VehicleFeatures | undefined | null,
): features is Features {
    return !!features && !Array.isArray(features);
}

export interface Vehicle {
    id: number;
    code: string;
    name: string;
    model: string;
    img: string;
    featured: number;
    isUpdateCategory: boolean;
    vehicleTypeId?: number;
    vehicleTypeName?: string;
    inventory?: number;
    showInventory?: boolean;
    features: VehicleFeatures;
    charges: Charges;
}

export interface Discount {
    coupon: string;
    method: string;
    percentage: number;
    availableUpgrade: boolean;
    originCategory: number;
    returnCategory: number;
}

export interface Schedule {
    pickUp: string;
    return: string;
}

export interface BranchParams {
    id_sucursal_renta: any;
    id_sucursal_devolucion?: any;
    fRenta: any;
    hRenta: any;
    fDevolucion: any;
    hDevolucion: any;
    cupon?: any;
}
